import { Component, OnInit, Input, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { KindBoard } from 'src/utils/enums';
import { InputItem } from '../../inputcommon/inputcommon.class';
import { InputContract } from '../inputmodels/inputcontract.model';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-input-quantity-contract',
    templateUrl: './inputquantitycontract.component.html',
    styleUrls: ['./inputquantitycontract.component.css'],
    standalone: false
})
export class InputQuantityContractComponent extends PageBase implements OnInit, OnChanges {

  @Input() inputQuantityContract: InputContract = new InputContract();
  @Input() isHideLoading: boolean;
  inputItem: InputItem = new InputItem();
  graphicOpacity = 1;
  startLegend: string;
  endLegend: string;
  percentage: number;
  amountValue: number;
  measuredValue: number;
  kindInsumo: KindBoard = KindBoard.Insumo;

  constructor(public contextApplication: ContextApplication,
              public objInjector: Injector)
  {
    super(objInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.resete();
  }

  private resete() {
    this.inputQuantityContract.id = 0;
    this.inputQuantityContract.contractedAmountQuantity = 0;
    this.inputQuantityContract.contractedAmountValue = 0;
    this.inputQuantityContract.measuredQuantity = 0;
    this.inputQuantityContract.measuredValue = 0;
    this.inputQuantityContract.percentageQuantityMeasuredUnderContracted = 0;
    this.inputQuantityContract.percentageValueMeasuredUnderContracted = 0;
    this.inputQuantityContract.quantityReleased = 0;
    this.inputQuantityContract.percentageQuantityReleasedUnderMeasured = 0;
    this.inputQuantityContract.valueReleased = 0;
    this.inputQuantityContract.percentageValueReleasedUnderMeasured = 0;
    this.graphicOpacity = 1;
    this.startLegend = '';
    this.endLegend = '';
    this.percentage = 0;
    this.amountValue = 0;
    this.measuredValue = 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inputQuantityContract) {
      this.load();
    }
  }

  private validateChartsWithContext() {
    if (this.contextApplication.currentVision == KindBoard.Insumo.valueOf()) {
      this.startLegend = this.literalsCp?.strMedido;
      this.endLegend = this.literalsCp?.strContratado;
      this.percentage = this.inputQuantityContract?.percentageQuantityMeasuredUnderContracted;
      this.amountValue = this.inputQuantityContract?.contractedAmountQuantity;
      this.measuredValue = this.inputQuantityContract?.measuredQuantity;
    }
    else {
      this.startLegend = this.literalsCp?.strLiberado;
      this.endLegend = this.literalsCp?.strMedido;
      this.percentage = this.inputQuantityContract?.percentageQuantityReleasedUnderMeasured;
      this.amountValue = this.inputQuantityContract?.quantityReleased;
      this.measuredValue = this.inputQuantityContract?.measuredQuantity;
    }
  }

  async load() {
    if (typeof (this.inputQuantityContract.errorList) !== 'undefined' && this.inputQuantityContract.errorList.length > 0
      && this.inputQuantityContract.errorList[0].message?.length > 0) {
      this.graphicOpacity = 0.1;
    }
    this.validateChartsWithContext();
  }

  onReceiveLiterals(): void {}
}
